import subheaderSlice, {
  SubheaderState as SubheaderStateType,
} from "./subheaderSlice";

export const { actions, reducer } = subheaderSlice;

export { default as subheaderLogic } from "./subheaderLogic";

export type SubheaderState = SubheaderStateType;
